import { jsxs, jsx } from 'react/jsx-runtime';
import { styled, css } from 'styled-components';
import { useQueryUserInfo } from '../../../user/queries/useQueryUserInfo.js';
import { IconEmptyCactus } from '@fabric-app/icons/old';
import { Image } from '@fabric-app/compat';
import { Flex } from '@fabric-app/ui/components/Flex';
import { cssVar } from '@fabric-app/ui/theme/variables';

const ResourceListEmptyStateBase = ({ title, image, description, size = "fill-container" }) => {
  const { data: user } = useQueryUserInfo();
  const defaultEmptyStateTitle = !user ? "Nothing here yet!" : "Let's add our first item!";
  const defaultEmptyListMessage = !user ? void 0 : "You can drag, paste anything – if you can think of it, you can do it here";
  return /* @__PURE__ */ jsxs(Container, {
    size,
    children: [
      image || image !== null && /* @__PURE__ */ jsx(EmptyStateImage, {
        variant: "default-list"
      }),
      /* @__PURE__ */ jsx(Title, {
        children: title ?? defaultEmptyStateTitle
      }),
      /* @__PURE__ */ jsx(EmptyStateDescription, {
        children: description || defaultEmptyListMessage
      })
    ]
  });
};
const EmptyStateImage = ({ variant = "default-list", src, width, height }) => {
  if (variant === "cactus") {
    return /* @__PURE__ */ jsx(IconEmptyCactus, {
      height: 201,
      width: 181
    });
  }
  return /* @__PURE__ */ jsx(Image, {
    src: src || "/images/empty-fdoc-list.png",
    height: height ?? 141,
    width: width ?? 201,
    alt: "Empty",
    draggable: false
  });
};
const EmptyStateDescription = styled.div.withConfig({
  displayName: "ResourceListEmptyState__EmptyStateDescription",
  componentId: "sc-6065d462-0"
})([
  `font-weight:500;font-size:14px;line-height:18px;max-width:500px;color:`,
  `;opacity:0.5;> a{text-decoration:underline;}`
], cssVar["color-text-tertiary"]);
const Container = styled(Flex).attrs({
  alignItems: "center",
  justifyContent: "center",
  direction: "column"
}).withConfig({
  displayName: "ResourceListEmptyState__Container",
  componentId: "sc-6065d462-1"
})([
  `flex-grow:1;width:100%;text-align:center;padding:3rem 2rem;gap:1rem;color:`,
  `;`,
  ``
], cssVar["color-text-primary"], (p) => {
  switch (p.size) {
    case "fill-container":
      return css([
        `height:100%;`
      ]);
    case "at-top":
      return css([
        `height:max-content;`
      ]);
  }
});
const Title = styled.h1.withConfig({
  displayName: "ResourceListEmptyState__Title",
  componentId: "sc-6065d462-2"
})([
  `font-weight:700;font-size:32px;line-height:44px;opacity:0.5;`
]);
const ResourceListEmptyState = Object.assign(ResourceListEmptyStateBase, {
  Image: EmptyStateImage,
  Description: EmptyStateDescription
});

export { ResourceListEmptyState };
//# sourceMappingURL=ResourceListEmptyState.js.map
